export default "__VITE_ASSET__DZzP0Ozh__"